import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';

Swiper.use([Navigation]);
export function initColorSchemePhotoSlideShows() {
  const slideshowEls = document.querySelectorAll<HTMLElement>('.js-slideshows');

  slideshowEls.forEach(swiperElement => {
    const parentElement = swiperElement.closest('.color-scheme-overview-tile')!;
    const options: SwiperOptions = {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      navigation: {
        nextEl: parentElement.querySelector(
          '.js-btn-slideshow-next',
        ) as HTMLElement,
        prevEl: parentElement.querySelector(
          '.js-btn-slideshow-prev',
        ) as HTMLElement,
      },
    };

    new Swiper(swiperElement, options);
  });
}
